export enum orderDirectionEnum {
	buy = 'buy',
	sell = 'sell'
}

export const ORDER_DIRECTION_LABEL = {
	buy: 'Achat',
	sell: 'Vente'
}
